import { render, staticRenderFns } from "./globalMenu.vue?vue&type=template&id=7b7d51d8&"
import script from "./globalMenu.vue?vue&type=script&lang=ts&"
export * from "./globalMenu.vue?vue&type=script&lang=ts&"
import style0 from "./globalMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports